﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:GridMultiselectController
 * @description
 * # GridMultiselectController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('GridMultiselectController', ['$scope', function ($scope) {
      $scope.settings = { enableSearch: true, smartButtonMaxItems: 2 };
      $scope.names = angular.copy($scope.grid.appScope.multiselectOptions[$scope.col.colDef.fieldName]);
      var selectedValues = $scope.grid.appScope.editRecord && $scope.grid.appScope.editRecord.entity[$scope.col.field] ? $scope.grid.appScope.editRecord.entity[$scope.col.field].split(';') : [];
      if (selectedValues && selectedValues.length > 0) {
          $scope.selectedNames = selectedValues.map(function (value) { return { id: value, value: value }; });
      } else {
          $scope.selectedNames = [];
      }

      $scope.$watch('selectedNames', function () {
          $scope.grid.appScope.editRecord.entity[$scope.col.field] = $scope.selectedNames && $scope.selectedNames.length > 0 ? $scope.selectedNames.map(function (item) { return item.id; }).join(";") : null;
      }, true);
  }]);